import React, { FC, useEffect, useState } from "react";
import { Input, Button, Row, Col, Radio } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import _ from "lodash";
import { useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import { Form } from "antd";
import useLocalStorageService from "../../services/localStorage";
import { SocketTopics } from "../../constants/enums";
import { CID, RID } from "../../constants/localStoreKeys";
import { pushNotification } from "utils/notifications";
import { useDispatch } from "react-redux";
import {
  INVITE_USER,
  GET_FRIEND_PAGE
} from "reducers/authReducer";
import {
  getMessageRequestPayload,
  wrapRequestPayload,
} from "../../helpers/request/RequestPayload";

import { getModifyPageSubscriptionTopic, getPageRequestPublishTopic, inviteExternalUsersTopic } from "hooks/MQTTConstants";
import './InvitePeople.scss';

const InvitePeopleModal: FC<{ onClose: () => void; socket?: ISocket; page?: boolean }> = (
  props
) => {
  const { onClose, socket, page } = props;
  const { selectedItem } = useSelector((state: RootState) => state.search);
  const [registerForm] = Form.useForm();
  const { getLocalStorageItem } = useLocalStorageService();
  const [error, setError] = useState<string>("");
  const [saving, setSaving] = useState(false);
  const [type, setType] = useState("email");

  const dispatch = useDispatch();


  useEffect(() => {
    if (saving) {
      registerForm.resetFields();
      setSaving(false);
      pushNotification("Invitation sent successfully", "success");
      onClose();
    }
  }, [selectedItem]);

  const sendPageUpdateEvent = (type, attributes) => {
    const modifyPagePayload: IMessage = getMessageRequestPayload(
      getLocalStorageItem(CID),
      getLocalStorageItem(RID),
      selectedItem.pageId,
      "",
      type,
      attributes
    );
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getModifyPageSubscriptionTopic(selectedItem.pageId),
      wrapRequestPayload(modifyPagePayload)
    );
  };


  const iviteUser = (notificationChannels: any, nickname: string) => {
    let expiresAt = new Date();
    expiresAt.setDate(expiresAt.getDate() + 1);

    dispatch(INVITE_USER({
      requestData: {
        notificationChannels: notificationChannels,
        nickname: nickname,
        pageId: selectedItem.pageId,
        pending: {invited: true, expiresAt: expiresAt.getTime()}
      },
      callback: (response) => {
        // const formattedResponse = formatAggregateUserResponse(response);
        // console.log("aggregate user response", formattedResponse);
        // setAggregateUsers(formattedResponse);
        // setIsLoading(false);

        socket.publishToEvent(
          SocketTopics.PublishPageTopics,
          getPageRequestPublishTopic(),
          {
            id: selectedItem.pageId,
            data: {
              objectId: selectedItem.pageId,
              paths: ["$"],
              returnPaths: ["$"],
              resultType: "value",
            },
          }
        );
        
        setSaving(false);
        registerForm.resetFields();
        pushNotification("Invitation sent successfully", "success");
        onClose();
      },
    }));

  
  };


  const onSubmitHandler = async (values: any) => {
    const { email, phone, nickname } = values;
    setError("");
    if (!email && !phone) {
      setError("Please enter email or phone number");
      return;
    }

    // const notificationChannels = [];
    // if (email) notificationChannels.push({ email });
    // if (phone) notificationChannels.push({ phone });

    setSaving(true);

    if (page) {
      // sendPageUpdateEvent("addPageNonBeamerMember", {
      //   role: "write",
      //   invitation: { notificationChannels },
      //   nickname
      // });


      iviteUser({email, phone}, nickname);
      



    }
    else {
      // socket.publishToEvent(
      //   SocketTopics.PublishPageTopics,
      //   inviteExternalUsersTopic(),
      //   wrapRequestPayload({
      //     userId: localStorage.getItem('RID'),
      //     notificationChannels: {
      //       email,
      //       phone
      //     },
      //     nickname
      //   }),
      // );


      dispatch(INVITE_USER({
        requestData: {
          notificationChannels: {email, phone},
          nickname: nickname,
          userId: localStorage.getItem('RID'),
        },
        callback: (response) => {
          // const formattedResponse = formatAggregateUserResponse(response);
          // console.log("aggregate user response", formattedResponse);
          // setAggregateUsers(formattedResponse);
          // setIsLoading(false);
          console.log("response", response);

          // socket.publishToEvent(
          //   SocketTopics.PublishPageTopics,
          //   getPageRequestPublishTopic(),
          //   {
          //     id: response.pageId,
          //     data: {
          //       objectId: response.pageId,
          //       paths: ["$"],
          //       returnPaths: ["$"],
          //       resultType: "value",
          //     },
          //   }
          // );

          dispatch(GET_FRIEND_PAGE({ friendUserId: response.memberId }));
          
          setSaving(false);
          registerForm.resetFields();
          pushNotification("Invitation sent successfully", "success");
          onClose();
        },
      }));


    }
  };
  const onChange = e => {
    setType(e.target.value);
  };

  return (
    <Form
      className="auth-form"
      name="register-form"
      id="register-form"
      layout="vertical"
      form={registerForm}
      onFinish={onSubmitHandler}
      requiredMark={false}
    >
      <Row className="d-flex mt-1 mb-4">
        <Col span={24}>
          <h3>
            <button style={{ verticalAlign: "bottom" }} onClick={onClose} className="b-0 rm-b">
              <ArrowLeftOutlined /></button>
            Invite via
          </h3>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Radio.Group onChange={onChange} value={type}>
            <Radio value="email">Email</Radio>
            <Radio value="phone">Phone</Radio>
          </Radio.Group>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col span={24}>
          <Form.Item
            name="nickname"
            rules={[
              {
                required: true,
                message: "**Required field",
              },
            ]}
          >
            <Input placeholder="Nickname" />
          </Form.Item>
        </Col>
        <Col span={24}>
          {type === "email" && (
            <Form.Item
              name="email"
              rules={[
                {
                  type: "email",
                  message: "The input is not valid Email!",
                },
                {
                  required: true,
                  message: "**Required field",
                },
              ]}
            >
              <Input type="email" placeholder="Email" />
            </Form.Item>
          )}

          {type === "phone" && (
            <Form.Item name="phone" rules={[
              {
                required: true,
                message: "**Required field",
              },
            ]}>
              <Input type="text" placeholder="Phone number (include +)" />
            </Form.Item>
          )}
          {error && (
            <Form.Item>
              <p className="error">{error}</p>
            </Form.Item>
          )}
        </Col>
      </Row>
      <Row className="action-grp">
        <Col span={24} className="pr-2">
          <Form.Item>
            <Button
              className="beam-btn green-btn cover w-full"
              loading={saving}
              type="primary"
              htmlType="submit"
              onClick={() => setError("")}
            >
              Invite
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default InvitePeopleModal;
